<!-- 导航栏 -->
<template>
  <div>
    <div v-for="(item, index) in Routerlist" :key="index + item.title + 'menu'">
      <template v-if="!item.children">
        <p
          class="title"
          style="cursor: pointer"
          :class="{ along: item.title === name }"
          @click="RouterClick(item)"
          v-show="item.show === undefined ? true : item.show"
        >
          {{ item.title }}
        </p>
      </template>
      <template v-if="item.children">
        <p
          class="title"
          v-if="item.title"
          style="cursor: pointer"
          @click="showChild(item)"
        >
          <span>{{ item.title }}</span>
          <img src="@/assets/img/down.svg" alt="" :class="{ up: !item.hide }" />
        </p>
        <ul v-if="!item.hide">
          <li
            v-for="(item_1, index_1) in item.children"
            :class="['res-tag', { on: item_1.name === name }]"
            :key="index_1 + item_1.name"
            @click="RouterClick(item_1)"
            v-show="item_1.show === undefined ? true : item_1.show"
          >
            <img
              v-show="item_1.name == '已选课程'"
              src="@/assets/img/selected.svg"
              class="selected_svg"
            />
            <img
              v-show="item_1.name == '待选课程'"
              src="@/assets/img/waiting.svg"
              class="selected_svg"
            />
            <a href="javascript:;">{{ item_1.name }}</a>
          </li>
        </ul>
      </template>
    </div>
  </div>
</template>

<script>
import { getTicket } from "@/api/user/userCenter.js";
export default {
  name: "Menu",
  props: {
    tabType: {
      type: String,
      default: "Cost",
    },
    roles: {
      type: String,
      default: "school",
    },
  },
  data() {
    return {
      name: "",
      Routerlist: [],
      usessionid: sessionStorage.getItem("usessionid") || "",
    };
  },
  watch: {
    tabType(newVal) {
      this.handleMenuData(newVal);
    },
    $route(n, o) {
      if (
        n.path === "/courseManager/materialManger" ||
        n.path === "/supervise/material"
      ) {
        this.name = "材料管理";
      } else if (n.path === "/education/mechanism/orginManagement") {
        this.name = "机构管理";
      }
    },
  },
  computed: {},
  created() {
    console.log(
      "进入menu---type----",
      JSON.parse(window.sessionStorage.getItem("type")).type
    );
    // 根据参数来进行应用菜单的跳转
    if (JSON.parse(window.sessionStorage.getItem("type")).type == "mechanism") {
      if (sessionStorage.getItem("linktype") == "classTable") {
        this.handleMenuData("timetable");
      } else if (sessionStorage.getItem("linktype") == "courseManagement") {
        this.handleMenuData("supervise");
      } else if (sessionStorage.getItem("linktype") == "orgManagement") {
        this.handleMenuData("personnel");
      } else {
        this.handleMenuData("homeViews");
      }
    } else if (
      JSON.parse(window.sessionStorage.getItem("type")).type == "school"
    ) {
      if (sessionStorage.getItem("linktype") == "homework") {
        this.handleMenuData("Task");
      } else if (sessionStorage.getItem("linktype") == "classTable") {
        this.handleMenuData("schedule");
      } else if (sessionStorage.getItem("linktype") == "otherCourseSelection") {
        this.handleMenuData("otherCourseSelection");
      } else if (sessionStorage.getItem("linktype") == "courseManagement") {
        this.handleMenuData("courseManager");
      } else {
        this.handleMenuData("HomeOverview");
      }
    } else {
      if (sessionStorage.getItem("linktype") == "homework") {
        this.handleMenuData("educationTask");
      } else if (sessionStorage.getItem("linktype") == "classTable") {
        this.handleMenuData("tableClass");
      } else if (sessionStorage.getItem("linktype") == "courseManagement") {
        this.handleMenuData("educationCourseManager");
      } else if (sessionStorage.getItem("linktype") == "orgManagement") {
        this.handleMenuData("eduMechanism");
      } else if (sessionStorage.getItem("linktype") == "riskWarn") {
        this.handleMenuData("riskWarning");
      } else {
        this.handleMenuData("homePageEducation");
      }
    }
  },
  methods: {
    async RouterClick(item) {
      // 保存左侧菜单位置
      sessionStorage.menuPath = item.path;
      let platformCode = sessionStorage.getItem("platformCode");
      if (item.title === "机构设置" && item.path === "/personnel/setting") {
        let ticket = await getTicket(this.usessionid);
        console.log("跳转机构设置--");
        window.open(
          `${sessionStorage.uc7manageUrl}/user/frontend/login/index/login-by-ticket?ticket=${ticket}&platformcode=${platformCode}`
        );
      } else if (
        item.title === "日常巡查" &&
        item.path === "/routineInspections"
      ) {
        let ticket = await getTicket(this.usessionid),
          url;
        if (sessionStorage.getItem("loginPlatformCode") == "420100" || sessionStorage.getItem("loginPlatformCode") == "999999" ) {
          url = `https://zhxy-app-inspect.huijiaoyun.com/?ticket=${ticket}&platformcode=${platformCode}`;
        } else {
          // 根据各平台的工程名来切换网关地址
          url = `https://zhxy-app-inspect.${sessionStorage.getItem(
            "platformProject"
          )}.com/?ticket=${ticket}&platformcode=${platformCode}`;
        }

        window.open(url);
      } else if (
        item.title === "学生请假" &&
        item.path === "/studentLeave"
      ) {
        let ticket = await getTicket(this.usessionid),
          url;
        if (sessionStorage.getItem("loginPlatformCode") == "420100" || sessionStorage.getItem("loginPlatformCode") == "999999" ) {
          url = `https://zhxy-app-stuleave.huijiaoyun.com/?ticket=${ticket}&platformcode=${platformCode}`;
        } else {
          // 根据各平台的工程名来切换网关地址
          url = `https://zhxy-app-stuleave.${sessionStorage.getItem(
            "platformProject"
          )}.com/?ticket=${ticket}&platformcode=${platformCode}`;
        }

        window.open(url);
      } else if (
        item.name === "教师评价管理" &&
        item.path === "/service/evaluationTeacher"
      ) {
        let ticket = await getTicket(this.usessionid),
          url;

        if (sessionStorage.getItem("loginPlatformCode") == "420100") {
          url = `https://zhxy-app-evaluate.huijiaoyun.com/?ticket=${ticket}&platformcode=${platformCode}`;
        } else {
          // 根据各平台的工程名来切换网关地址
          url = `https://zhxy-app-evaluate.${sessionStorage.getItem(
            "platformProject"
          )}.cn/?ticket=${ticket}&platformcode=${platformCode}`;
        }
        window.open(url);
      } else if (
        item.title === "信息公开" &&
        item.path === "/education/operatingManager/public"
      ) {
        let url = `${sessionStorage.getItem(
          "domain"
        )}/index.php?r=znews/index/content`;
        window.open(url);
      } else if (
        item.title === "通知公告" &&
        item.path === "/education/operatingManager/notice"
      ) {
        let ticket = await getTicket(this.usessionid);
        let url = `http://notice.huijiaoyun.com/index.php?ticket=${ticket}&platformcode=${platformCode}`;
        window.open(url);
      } else {
        this.name = item.name || item.title;
        if (this.$route.path == item.path) {
          // 点击当前导航刷新页面
          this.$router.push({
            name: "back",
            params: {
              link: item.path, //当前路由
            },
          });
        } else {
          this.$router.push(item.path);
        }
      }
    },

    handleMenuData(type) {
      switch (type) {
        // =========================学校=========================
        case "HomeOverview": // 首页概览(学校)
          this.Routerlist = [{ title: "首页概览", path: "/HomeOverview" }];
          this.name = "首页概览";
          this.$router.push("/HomeOverview");
          break;
        case "courseManager": // 课程管理
          this.Routerlist = [
            {
              title: "",
              children: [
                // { name: "全部课程", path: "/courseManager/allCourse" },
                // { name: "学校课程库", path: "/courseManager/selfAddCourse" },
                { name: "机构课程库", path: "/courseManager/importCourse" },
                { name: "系统课程库", path: "/courseManager/systemCourse" },
                // { name: "材料管理", path: "/courseManager/materialManger" },
                // { name: "巡课管理", path: "/courseManager/tourCourse" },
              ],
            },
          ];
          break;
        case "courseSelection": // 校本选课
          this.Routerlist = [
            {
              title: "",
              children: [
                { name: "选课活动", path: "/CourseSelection/activity" },
                { name: "选课类型", path: "/CourseSelection/type" },
              ],
            },
          ];
          break;
        case "schedule": // 学校-延时课表
          this.Routerlist = [{ title: "延时课表", path: "/schedule" }];
          break;
        case "otherCourseSelection": // 学校-校本选课独立应用
          this.Routerlist = [
            {
              title: "",
              children: [
                { name: "待选课程", path: "/courseSelectionWaiting" },
                { name: "已选课程", path: "/courseSelectionSelected" },
              ],
            },
          ];
          break;
        case "Task": // 作业管理
          //用户类型 G3管理员 G1学科组长 hTeacher班主任 teacher普通老师
          let tempList = [
            {
              role: ["G3", "G1", "hTeacher", "teacher"],
              show: false,
              title: "作业登记",
              path: "/task/register",
            },
            {
              role: ["G3", "G1", "hTeacher", "teacher"],
              show: false,
              title: "作业调控",
              path: "/task/regulation",
            },
            {
              role: ["G3", "G1"],
              show: false,
              title: "作业备案",
              path: "/task/record",
            },
            {
              role: ["G3", "G1", "hTeacher", "teacher"],
              show: false,
              title: "作业反馈",
              path: "/task/feedback",
            },
            //  {
            //   role: ["G3", "G1", "hTeacher", "teacher"],
            //   show: false,
            //   title: "作业分析",
            //   path: "/task/analysis",
            // },
            // {
            // 	title: "作业辅导",
            // 	path: "/task/tutoring",
            // },
            // {
            // 	role: ["G3", "G1", "hTeacher"],
            // 	show: false,
            // 	title: "作业分析",
            // 	children: [
            // 		{
            // 			role: ["G3", "G1", "hTeacher"],
            // 			show: false,
            // 			name: "作业设计质量",
            // 			path: "/task/analysis/quality",
            // 		},
            // 		{
            // 			role: ["G3", "G1", "hTeacher"],
            // 			show: false,
            // 			name: "作业调控备案",
            // 			path: "/task/analysis/regulationRecord",
            // 		},
            // 		{
            // 			role: ["G3"],
            // 			show: false,
            // 			name: "作业评审情况",
            // 			path: "/task/analysis/reviewSituation",
            // 		},
            // 		{
            // 			role: ["G3", "G1", "hTeacher"],
            // 			show: false,
            // 			name: "作业反馈异常",
            // 			path: "/task/analysis/feedbackAbnormal",
            // 		},
            // 	],
            // },
          ];
          let userType = sessionStorage.userType;
          tempList.forEach((item) => {
            if (item.role?.includes(userType)) {
              item.show = true;
            }
            item.children?.forEach((child) => {
              if (child.role?.includes(userType)) {
                child.show = true;
              }
            });
          });
          this.Routerlist = tempList;
          break;
        case "statistical": // 统计分析
          this.Routerlist = [
            // {
            //   title: "课程统计",
            //   children: [
            //     { name: "课程开班统计", path: "/statistical/ShiftStatistics" },
            //     {
            //       name: "机构课程统计",
            //       path: "/statistical/HostingStatistics",
            //     },
            //     {
            //       name: "学生托管统计",
            //       path: "/statistical/HostingStudentBution",
            //     },
            //   ],
            // },
            {
              title: "考勤统计",
              children: [
                // {
                //   name: "学生考勤统计",
                //   path: "/statistical/HostingStudentSign",
                // },
                {
                  name: "教师考勤统计",
                  path: "/statistical/HostingTeacherClass",
                },
                {
                  name: "课程考勤统计",
                  path: "/statistical/AttendanceStatistics",
                },
              ],
            },
            {
              title: "评价统计",
              children: [
                { name: "课程评价统计", path: "/statistical/evaluationCourse" },
                // {
                //   name: "教师评价统计",
                //   path: "/statistical/evaluationTeacher",
                // },
              ],
            },
          ];
          break;
        case "service": // 服务管理
          this.Routerlist = [
            {
              title: "费用管理",
              children: [
                { name: "订单管理", path: "/service/Order" },
                { name: "课酬管理", path: "/service/Money" },
                { name: "结算管理", path: "/service/Settlement" },
              ],
            },
            // {
            //   title: "评价管理",
            //   children: [
            //     { name: "课程评价管理", path: "/service/evaluationCourse" },
            //     { name: "教师评价管理", path: "/service/evaluationTeacher" },
            //     // { name: "学生评价管理", path: "/service/evaluationStudent" },
            //   ],
            // },
            // {
            //   title: "投诉管理",
            //   children: [
            //     { name: "课程投诉管理", path: "/service/complaintsCourse" },
            //     { name: "教师投诉管理", path: "/service/complaintsTeacher" },
            //     { name: "收费投诉管理", path: "/service/evaluationCharge" },
            //   ],
            // },
            {
              title: "日常巡查",
              path: "/routineInspections",
            },
             {
              title: "学生请假",
              path: "/studentLeave",
            },
          ];
          break;

        // =========================机构=========================
        case "homeViews": // 首页概览(机构)
          this.Routerlist = [{ title: "首页概览", path: "/homeViews" }];
          break;
        case "personnel": // 机构管理
          this.Routerlist = [
            // {
            //   title: "人员管理",
            //   children: [
            //     { name: "在职人员管理", path: "/personnel/onJob" },
            //     { name: "离职人员管理", path: "/personnel/outJob" },
            //     { name: "黑名单人员管理", path: "/personnel/badMen" },
            //   ],
            // },
            { title: "人员管理", path: "/personnel/onJob" },
            {
              title: "机构设置",
              path: "/personnel/setting",
              // url: "http://uc.d.huijiaoyun.com/user/home",
              url: "https://manage.wuhaneduyun.cn/user/home", //武汉平台的后台设置
            },
          ];
          break;
        case "supervise": // 课程监管
          this.Routerlist = [
            {
              title: "课程管理",
              path: "/supervise/curriculum",
            },
            {
              title: "材料管理",
              path: "/supervise/material",
            },
          ];
          if (process.env.VUE_APP_MODE !== "prod") {
            this.Routerlist.push({
              title: "开课列表",
              path: "/supervise/openClass",
            });
          }
          break;
        case "analysis": // 统计分析(机构)
          this.Routerlist = [
            {
              title: "课程开班统计",
              path: "/statistical/openClass",
            },
            {
              title: "课程评价统计",
              path: "/statistical/evaluate",
            },
            {
              title: "教师考勤统计",
              path: "/statistical/teacher",
            },
            {
              title: "学生考勤统计",
              path: "/statistical/studnetAttendance",
            },
          ];
          break;
        case "timetable": // 机构-延时课表
          this.Routerlist = [
            {
              title: "延时课表",
              path: "/timetable",
            },
          ];
          break;
        case "operate": // 运营管理
          this.Routerlist = [
            {
              title: "费用管理",
              children: [
                { name: "订单管理", path: "/cost/order" },
                { name: "课酬管理", path: "/cost/classPay" },
                { name: "结算管理", path: "/cost/settlement" },
              ],
            },
            {
              title: "评价管理",
              path: "/operate/evaluate",
            },
            {
              title: "支付渠道管理",
              path: "/operate/payChannel",
            },
            // {
            //   title: "投诉管理",
            //   children: [
            //     { name: "课程投诉管理", path: "/complaint/class" },
            //     { name: "教师投诉管理", path: "/complaint/teacher" },
            //     { name: "收费投诉管理", path: "/complaint/charge" },
            //   ],
            // },
          ];
          // if (process.env.VUE_APP_MODE !== "prod") {
          //   this.Routerlist.push({
          //     title: "支付渠道管理",
          //     path: "/operate/payChannel",
          //   });
          // }
          break;
        case "notice":
          this.Routerlist = [{ title: "通知公告", path: "/notice" }];
          break;

        // =========================教育局=========================
        case "homePageEducation": // 首页概览
          this.Routerlist = [{ title: "首页概览", path: "/homePageEducation" }];
          break;
        case "educationCourseManager": // 课程管理
          if (
            sessionStorage.getItem("user_level") === "99" ||
            ["1", "10"].indexOf(sessionStorage.getItem("user_level")) > -1
          ) {
            this.Routerlist = [
              {
                title: "课程监管",
                path: "/education/courseManager/city/courseSupervise",
              },
              {
                title: "材料监管",
                path: "/education/courseManager/city/materialSupervise",
              },
            ];
          } else {
            this.Routerlist = [
              {
                title: "课程管理",
                path: "/education/courseManager/area/courseManager",
              },
              // {
              //   title: "材料管理",
              //   path: "/education/courseManager/area/materialManager",
              // },
            ];
          }
          // 课程类目管理
          if (process.env.VUE_APP_MODE !== "prod") {
            this.Routerlist.push({
              title: "课程类目管理",
              children: [
                {
                  name: "五育课程类目设置",
                  path: "/education/courseManager/teachingSetting",
                },
                {
                  name: "素质课程类目设置",
                  path: "/education/courseManager/qualitySetting",
                },
                {
                  name: "类目展示设置",
                  path: "/education/courseManager/showSetting",
                },
              ],
            });
          }
          break;
        case "eduMechanism": // 机构管理
          this.Routerlist = [
            {
              title: "机构管理",
              path: "/education/mechanism/orginManagement",
            },
            // {
            //   title: "监管账户",
            //   path: "/education/mechanism/regulatoryAccount",
            // },
            { title: "人员管理", path: "/education/mechanism/onJob" },
            // {
            //   title: "人员管理",
            //   children: [
            //     { name: "在职从业人员", path: "/education/mechanism/onJob" },
            //     { name: "离职从业人员", path: "/education/mechanism/outJob" },
            //     {
            //       name: "从业人员黑名单",
            //       path: "/education/mechanism/blacklist",
            //     },
            //   ],
            // },
          ];
          break;
        case "educationTask": // 教育局-作业管理
          this.Routerlist = [
            {
              title: "",
              path: "/education/task/home",
            },
          ];
          break;
        case "operation": // 教育局-运营管理
          this.Routerlist = [
            {
              title: "评价管理",
              path: "/education/operatingManager/courseEvaluation",
            },
            {
              title: "通知公告",
              path: "/education/operatingManager/notice",
            },
            {
              title: "订单管理",
              children: [
                {
                  name: "订单管理",
                  path: "/education/operatingManager/orderManager/order",
                },
                {
                  name: "退费管理",
                  path: "/education/operatingManager/orderManager/refund",
                },
              ],
            },
          ];
          // 只有武汉平台的才能有信息公开
          if (JSON.parse(sessionStorage.userInfo).platform_code == "420100") {
            this.Routerlist.push({
              title: "信息公开",
              path: "/education/operatingManager/public",
            });
          }
          break;
        case "educationStatistical": // 教育局-统计分析
          this.Routerlist = [
            {
              title: "学校排课统计",
              path: "/education/statistical/outCourse",
            },
            {
              title: "学生托管统计",
              path: "/education/statistical/studentHosting",
            },
            {
              title: "学校开课统计",
              path: "/education/statistical/schoolClasses",
            },
            {
              title: "机构课程统计",
              path: "/education/statistical/institutionsCourseStatistics",
            },
            {
              title: "课程评价统计",
              path: "/education/statistical/courseEvaluation",
            },
          ];
          break;
        case "riskWarning": // 教育局-风险预警
          this.Routerlist = [
            // {
            //   title: "投诉预警",
            //   path: "/education/riskWarning/complaint",
            // },
            // {
            //   title: "人员预警",
            //   path: "/education/riskWarning/personnel",
            // },
            {
              title: "评价预警",
              path: "/education/riskWarning/evaluate",
            },
            // {
            //   title: "风险直送",
            //   path: "/education/riskWarning/riskSend",
            // },
          ];
          break;
        case "moneyManager": // 教育局-资金管理
          this.Routerlist = [
            {
              title: "交易记录",
              path: "/education/moneyManager/transactionRecord",
            },
            {
              title: "资金管理",
              path: "/education/moneyManager/moneyAdministration",
            },
            {
              title: "课酬管理",
              path: "/education/moneyManager/classPay",
            },
          ];
          break;
        case "tableClass": // 教育局-延时课表
          this.Routerlist = [
            {
              title: "延时课表",
              path: "/tableClass",
            },
          ];
          break;
      }
      if (
        type !== "schedule" &&
        type !== "HomeOverview" &&
        type !== "homePageEdu" &&
        this.Routerlist[0].children
      ) {
        this.name = this.Routerlist[0].children[0].name;
        this.$router.push(this.Routerlist[0].children[0].path);
      } else {
        this.name = this.Routerlist[0].title;
        this.$router.push(this.Routerlist[0].path);
      }
    },
    showChild(item) {
      this.$set(item, "hide", !item.hide);
    },
  },
};
</script>

<style lang="less" scoped>
.res-tag {
  display: flex;
  justify-items: center;
  align-items: center;
  a {
    padding-left: 18%;
  }
  &.on {
    background-color: #ffffff;
    border-left: 5px solid #4991e1;
    a {
      color: #4991e1;
      padding-left: 15.8%;
    }
  }
  &.clickable {
    cursor: pointer;
  }
  .selected_svg {
    display: inline-block;
    margin-left: 10px;
    width: 18px;
    height: 18px;
  }
}
.along {
  background-color: #ffffff;
  border-left: 5px solid #4991e1;
  cursor: pointer;
  p {
    color: #4991e1;
  }
}
.title {
  padding-left: 20px;
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #666;
  height: 52px;
  line-height: 52px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  img {
    width: 16px;
    height: 16px;
    margin-right: 10px;
  }
  .up {
    transform: rotate(180deg);
  }
}
ul > li {
  cursor: pointer;
  height: 46px;
  line-height: 46px;
  font-size: 16px;
  a {
    display: block;
    width: 100%;
    // text-align: center;
    padding-left: 40px;
    height: 100%;
    color: #666;
    font-family: PingFang SC;
    font-weight: 400;
  }
}
</style>
